define([
	'require',
	'jquery',
	'domReady',
	'wcs.product-views',
	'wcs.product-views-util',
	'wcs.context',
	'pubsub',
	'shared.main.plugins',
	'wcs.product-context',
	'shared.lazyload',
	'foundation.reveal',
	'vfdp.powerReviewsService',
	'foundation.util.keyboard'
], function(require, $, domReady, pdp, pdpUtil, ctx, pubsub, pluginLoader) {

    // Global Variables
    var DEBUG = false;
	var PLUGIN_IDENTIFIER = 'quickView';
	var initQuickViewContentExecuted = false;

	var QuickView = function(el, options) {
		this.element = el;
		this.options = options;
	};

	// Define the plugin's prototype and defaults
	QuickView.prototype = {

		/*default plugin options*/
		defaults: {
			modalID: '#modal', // ID of quickView modal
			modalClass: 'quickview-modal', // class of quickView modal
			closeButton: '.close-button', // class of close button within the modal
			modalMarkup: '<div id="modal" class="quickview-modal reveal medium" data-reveal>',  // modal markup for when no modal is found on page
			modalAttributeID: 'open',  // i.e. data-open which stores the ID of our modal
			modalRevealAttritbute: 'data-reveal',  // reveal data attribute on modal
			modalCloseEvent: 'closed.zf.reveal', // reveal modal closed event
			modalOpenEvent: 'open.zf.reveal', // reveal modal open event
			onComplete: null,  // callback function that triggers after modal is open
			quickShopDrawerMode: false // enable quickshop drawer mode
		},

		/**
		 * Initializes the plugin instance
		 * @returns {Object} This plugin instance
		 */
		init: function() {
			if (DEBUG) console.log('QuickView - Init');

			var self = this;

			// Merge various methods of providing plugin options into a single config object
			self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');

			self.config = $.extend(
				{}, // empty object to merge into
				self.defaults,
				self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
				self.metadata // options provided as HTML data attribute $(selector).data()
			);

			self.events();
			self._build();

			return self;
		},

		/**
		 * initQuickViewContent
		 * Populates pricing and enables favorites and power reviews
		 *
		 * NOTE: This function is self invoking and wrapped in a closure so we can control how many times it is executed.
		 * In this case, we only wish for this to be executed once for each click of a quickView instance; however, self.events()
		 * is bound for every instance on the page and open.zf.reveal will call this function for as many instances as are on the page
		 * if we do not have this closure in place
		 */
		initQuickViewContent: (function (quickviewWrapper) {
			return function(quickviewWrapper) {
				if (!initQuickViewContentExecuted) {
					initQuickViewContentExecuted = true;

					if (DEBUG) console.log('QuickView - Init QuickView Form');
				  	pluginLoader.runVFDPPlugins(quickviewWrapper);

		        	require(['wcs.tooltip'], function() {
			            $(document).trigger( 'QUICKSHOP_DISPLAY');
			            $.pubsub('publish', 'WCS_QUICKSHOP_OPENED');

			            var trackingDataContainer = quickviewWrapper.find('.tracking-product-data-js'); //Preventing incidentally reloading other plugins in the modal
			            if(trackingDataContainer.length > 0){ //Only if the tracking data is found, then the module is re-initialized
			                pluginLoader.runVFDPPlugins(trackingDataContainer);
			            }

			            pdp.setupQuickshop();
			            pdp.handleContextChangeQuickshop();
			            main.update();

			            if(WCS_CONFIG.global.favoritesEnabled && $('.favorites-icon-js').length > 0){
			                require(["wcs.favorites"],function(){
			                    $('#quickview-box .product-form-js').favorites();
			                });
			            }

			            var $powerReviewsContainer = quickviewWrapper.find('.power-reviews-service-js');
			            if ($powerReviewsContainer.length > 0) {
			                var moduleToReinitialize = "";

			                if (!$powerReviewsContainer.powerReviewsService || typeof $powerReviewsContainer.powerReviewsService !== "function") {
			                    moduleToReinitialize = "vfdp.powerReviewsService";
			                }

			                require([moduleToReinitialize], function () {
			                    var powerReviewsService = $powerReviewsContainer.powerReviewsService().data().powerReviewsService;
			                    powerReviewsService.initPowerReviews({
			                        ReviewSnippet: 'power-reviews-snippet-rating'
			                    });
			                });
			            }
			        });
		        }
	        };
		})(),

		closeQuickView: function () {
			if (DEBUG) console.log('QuickView - Close Quick View');
			var self = this;

			$(self.config.modalID).foundation('close');
		},

		/**
		 * openQuickView
		 * Triggered when our modal is opened
		 **/
		openQuickView: function() {
			var self = this;

			if (self.currentModal) {
				$(self.currentModal).addClass(self.config.modalClass);

				if(typeof self.config.onComplete === 'function') {
					self.config.onComplete.apply( self.element, arguments);
				}
			}

			self.initQuickViewContent($(self.config.modalID));
		},

		/**
		 * Remove the QuickView contents from the DOM so that they don't
		 * interfere with something openend another way
		 **/
		destroyQuickViewContent: function (el) {
			if (DEBUG) console.log('QuickView - Destroy Quick View');
			var self = this;

			initQuickViewContentExecuted = false;

			$(self.currentModal).removeClass(self.config.modalClass);
			$(el).empty();
		},

		handleWindowResize: function (screen_size) {
			if (DEBUG) console.log('QuickView - Window Resize');
			// Quickshop isn't optimal on small screens for some brands so we
			// close it when crossing into a small screen breakpoint
			if (screen_size === 'small') {
				var isSwatchesQuickview = $('.pdp-swatches').length,
					isCheckOutQuickview = $('#checkout').length;
				//hide quickview for swatches layout
				if (!isCheckOutQuickview && isSwatchesQuickview)  {
					closeQuickView();
				}
			}
		},

		setupDrawerMode: function() {
			if (DEBUG) console.log('QuickView - Setup Drawer Mode');
			var self = this,
					$overlay = $(self.config.modalID).parent(),
					$quickshopButton = $('.quickshop-js');

			$overlay.addClass('drawer-mode');

			if (!$overlay.find('.close-button-alt').length) {
				$overlay.append('<button type="button" class="close-button-alt"></button>');
			}

			$quickshopButton.on('click', function(event) {
				$overlay.removeClass(self.config.quickShopAnimationOut);
				$overlay.addClass(self.config.quickShopAnimationIn);
			});

			$overlay.on('click', '.close-button-alt', function(event) {
				self.destroyDrawer(event.currentTarget);
			});
		},

		destroyDrawer: function(target) {
			if (DEBUG) console.log('QuickView - Destroy Drawer');
			var self = this,
					animationDuration = 300, // should match same value set in CSS class
					$html = $('html'),
					$overlay = $(self.config.modalID).parent();

			$overlay.removeClass(self.config.quickShopAnimationIn);
			$overlay.addClass(self.config.quickShopAnimationOut);

			setTimeout(function() {
				if (DEBUG) console.log('QuickView - Animation Completed - Destroy Drawer');
				self.destroyQuickViewContent(target);
				$html.removeClass('is-reveal-open');
			}, animationDuration);
		},

		addModalToPageIfNotPresent: function () {
			if (DEBUG) console.log('QuickView - Add Modal to Page If Not Present');
			var self = this;

			if (!self.config.modalID) console.error('modalID is undefined.');

			if (self.config.modalID && $(self.config.modalID).length === 0) {
				$('body').append(self.config.modalMarkup);
			}
		},

		/**
		 * Binds plugin events
		 **/
		events: function() {
			if (DEBUG) console.log('QuickView - Events');

			var self = this;
			var quickviewWrapper = $(this.config.modalID);

			// NOTE: All of these events are being called twice per product. For a small list of products like the cart
			// page with a few items is no problem but in a PLP with more than 20 products can cause us some issues.

			// TODO: dive deeper to figure out why is the quickview modal is being called twice per product.

			// Checks if Scene7 viewer is ready so we can reset the Foundation Keyboard trap logic
			document.addEventListener('init.viewer.complete.ready', function(e) {
				if (DEBUG) console.log('QuickView - Events - S7 Ready', e, quickviewWrapper);
				Foundation.Keyboard.releaseFocus(quickviewWrapper);
				Foundation.Keyboard.trapFocus(quickviewWrapper);
			});

			$(self.element).on('click', function(e) {
                var $targetElement = $(e.currentTarget);
                var targetElementData = $targetElement.data();
                self.currentModal = targetElementData[self.config.modalAttributeID] ? '#' + targetElementData[self.config.modalAttributeID] : self.config.modalID;

                if (targetElementData.open) {
                    self.config.modalID = '#' + targetElementData.open;
                    self.config.$modalID = $(self.config.modalID);
                    self.config.$modalID.data('options', targetElementData);
                }

				pdpUtil.sizeChartSlideView($(self.currentModal));

				$(self.currentModal).one(self.config.modalCloseEvent, function(e) {
                  if (self.config.quickShopDrawerMode) {
                    self.destroyDrawer(e.currentTarget);
                  } else {
                    self.destroyQuickViewContent(e.currentTarget);
                  }
    	        });
			});

			// Init product-detail form for non-modal quickviews
			$.pubsub('subscribe','vfdp.wcs.quickview.init_product_detail_form', function(e, data) {
                initQuickViewContentExecuted = false;
				self.initQuickViewContent(data);
			});

			$('[' + self.config.modalRevealAttritbute + ']').on(self.config.modalOpenEvent, self.currentModal, function() {
	            self.openQuickView();
			});

			$.pubsub('subscribe', 'SHOPCART_UPDATED', function() {
				self.closeQuickView();
			});

            $.pubsub('subscribe', 'window.resize.breakpoint', function(e, data) {
                self.handleWindowResize(data.now);
            });
		},

		/**
		 * Modifies the DOM to support layout requirements
		 **/
		_build: function() {
			if (DEBUG) console.log('QuickView - Build');
			var self = this;
			self.addModalToPageIfNotPresent();

			if (self.config.quickShopDrawerMode) {
				self.setupDrawerMode();
			}
		}
	};

	// Create the instance defaults from the prototype
	QuickView.defaults = QuickView.prototype.defaults;

	// Register as a JQuery plugin and prevent duplicate instantiation
	$.fn[PLUGIN_IDENTIFIER] = function( options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if (!instance) {
				instance = new QuickView(this, options).init();
				$.data( this, PLUGIN_IDENTIFIER, instance);
			}
		});
	};
});
